module.exports = __webpack_public_path__ + "img/bullets-shuffle.590db8fd.svg";